import { VALIDATION_MESSAGE } from '../ValidationMessage';
import yup from './CustomValidation/yup-extended';

export const NeglectedOrDelinquentContactValidationSchema = yup.object().shape({
    firstName: yup.string().trim().required(VALIDATION_MESSAGE.REQUIRED),
    lastOrSurname: yup.string().trim().required(VALIDATION_MESSAGE.REQUIRED),
    position: yup.string(),
    email: yup
        .string()
        .trim()
        .email(VALIDATION_MESSAGE.MUST_BE_IN_VALID_EMAIL_FORMAT)
        .required(VALIDATION_MESSAGE.REQUIRED),
    telephone: yup
        .string()
        .required(VALIDATION_MESSAGE.REQUIRED)
        .matches(
            /^[1-9]\d{2}-\d{3}-\d{4}$/,
            VALIDATION_MESSAGE.MUST_BE_IN_PHONE_NUMBER_FORMAT
        ),
});
